export const hasLocalStorageFlag = (key: string): boolean => {
  try {
    const value = localStorage.getItem(key);

    return value === '1' || value === 'true' || value === 'yes' || value === 'on';
  } catch (e) {
    return false;
  }
};
